const tw = require('moment-taiwan');

export default (val, arg) => {
  if (!val) return;
  val = val.toString();
  return tw(val).format(arg);
};
